export default {
    data: function () {
        return {
            submitted: false,
            formErrors: {}
        }
    },

    methods: {
        clearInput(fieldName) {
            delete this.formErrors[fieldName];

            this.submitted = !!Object.keys(this.formErrors).length;
        },

        clearErrors() {
            this.formErrors = [];

            this.submitted = false;
        },

        resetForm(data) {
            Object.keys(data).forEach(function (key) {
                data[key] = '';
            });
        }
    }
}
